module.exports = __webpack_public_path__ + "img/03-B08.c2c7987c.png";